import * as LABELS_ACTION_TYPE from './labelConstants';
import { Label } from './labelTypes';
import { getNewTransactionId } from '../../client/utils/undoRedo/undoRedoTransactionManager';

export const loadLabels = (labels = []) => ({
    type: LABELS_ACTION_TYPE.LABELS_LOAD,
    labels,
});

export const createLabel = (label: Label) => ({
    type: LABELS_ACTION_TYPE.LABEL_CREATE,
    label,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const updateLabel = (labelId: string, changes: Partial<Label>) => ({
    type: LABELS_ACTION_TYPE.LABEL_UPDATE,
    labelId,
    changes,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const deleteLabel = (labelId: string) => ({
    type: LABELS_ACTION_TYPE.LABEL_DELETE,
    labelId,
    transactionId: getNewTransactionId(),
    sync: true,
});

export const addRootToLabel = (label: Label, rootIdToAdd: string) => {
    if (label.rootBoardIds.includes(rootIdToAdd)) return;

    const newRootBoardIds = [...label.rootBoardIds, rootIdToAdd];
    return updateLabel(label.id, { rootBoardIds: newRootBoardIds });
};
